"use client";

import React, { createContext, useState, useEffect } from "react";
import io from "socket.io-client";

const GameStatusContext = createContext();
const socket = io('wss://www.profitonn.com/', {
    path: '/ml-socket/socket.io',
});
// const socket = io("http://localhost:3001/");

export const GameStatusProvider = ({ children }) => {
  const [gameStatus, setGameStatus] = useState("Waiting for the game to start...");
  const [timeRemaining, setTimeRemaining] = useState(null);
  const [totalTimer, setTotalTimer] = useState(null);
  const [isButton1Disabled, setIsButton1Disabled] = useState(true);
  const [isButton2Disabled, setIsButton2Disabled] = useState(true);

  useEffect(() => {
    // Listen for gameStatus updates from the server
    socket.on("gameStatus", (data) => {
      setGameStatus(data.message);
      setIsButton1Disabled(data.button1Disabled);
      setIsButton2Disabled(data.button2Disabled);
      setTimeRemaining(data.totalSeconds);
      setTotalTimer(data.totalTimer);
    });

    return () => socket.off("gameStatus");
  }, []);

  console.log(isButton1Disabled, timeRemaining);
  // useEffect(() => {
  //   // Decrement local timer every second
  //   const interval = setInterval(() => {
  //     setTimeRemaining((prev) => Math.max(prev - 1000, 0));
  //   }, 1000);

  //   return () => clearInterval(interval);
  // }, []);

  return (
    <GameStatusContext.Provider
      value={{
        gameStatus,
        timeRemaining,
        isButton1Disabled,
        isButton2Disabled,
        totalTimer,
      }}
    >
      {children}
    </GameStatusContext.Provider>
  );
};

export default GameStatusContext;
